import { Waves, Compass, Sunset, Castle, Apple, Sparkles } from "lucide-react";
import { useT } from "../../i18n/LanguageContext";

const ICONS = [Waves, Compass, Sunset, Castle, Apple];

export default function SegredosSul() {
  const { t } = useT();
  const items = t.segredos.items;

  return (
    <section id="segredos" className="py-20 md:py-28 bg-noite text-[#faf6ee] relative overflow-hidden" data-testid="segredos-section">
      <div className="absolute -top-32 right-0 w-[28rem] h-[28rem] rounded-full bg-[#e3b25b]/8 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 left-0 w-[24rem] h-[24rem] rounded-full bg-[#2c5fb5]/15 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="reveal max-w-2xl">
          <p className="section-label">
            <Sparkles size={12} className="text-[#e3b25b]" /> {t.segredos.eyebrow}
          </p>
          <h2 className="font-display text-4xl md:text-6xl mt-4 leading-[1.05]">
            {t.segredos.title1} <em className="text-[#e3b25b]">{t.segredos.title2}</em>
          </h2>
          <p className="mt-4 text-[#faf6ee]/75 max-w-xl leading-relaxed">
            {t.segredos.subtitle}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
          {items.map((it, i) => {
            const Icon = ICONS[i] || Sparkles;
            const isMystery = i === 0;
            return (
              <article
                key={i}
                className={`reveal card-lift rounded-3xl p-7 ring-1 relative overflow-hidden ${
                  isMystery
                    ? "bg-[#1a2c5c]/70 ring-[#e3b25b]/40"
                    : "bg-[#1a2c5c]/45 ring-white/10"
                }`}
                data-testid={`segredo-${i}`}
              >
                {isMystery && (
                  <div className="absolute inset-0 opacity-25 pointer-events-none"
                       style={{ backgroundImage: "radial-gradient(circle at 2px 2px, rgba(227,178,91,0.45) 1px, transparent 1px)", backgroundSize: "16px 16px" }} />
                )}

                <div className="relative w-12 h-12 rounded-xl bg-[#e3b25b]/20 text-[#e3b25b] flex items-center justify-center">
                  <Icon size={22} strokeWidth={1.8} />
                </div>

                <p className="relative text-[10px] uppercase tracking-[0.22em] mt-5 font-semibold text-[#e3b25b]">
                  {it.tag}
                </p>
                <h3 className="relative font-display text-2xl mt-1.5 leading-tight">
                  <span className="text-[#faf6ee]">{it.t.split(" ").slice(0, -1).join(" ") || it.t}</span>{" "}
                  {it.t.split(" ").length > 1 && (
                    <em className="text-[#e3b25b]">{it.t.split(" ").slice(-1)}</em>
                  )}
                </h3>
                <p className="relative mt-4 text-sm leading-relaxed text-[#faf6ee]/75">
                  {it.d}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
